export default __webpack_public_path__ + "media/images/portfolio/gallery-03-802x1200_original-12ee90ad71ef4ed49cf4916d24f9b6a7.jpg";